<template>
    <div>
        <!--<div class="loader" v-if="isLoading() == true"><span class="load"></span></div>-->
        <div class="loader" v-if="isLoading() == true">
            <div class="preloader">
               <span style="--i:1;"></span>
               <span style="--i:2;"></span>
               <span style="--i:3;"></span>
               <span style="--i:4;"></span>
               <span style="--i:5;"></span>
               <span style="--i:6;"></span>
               <span style="--i:7;"></span>
               <span style="--i:8;"></span>
               <span style="--i:9;"></span>
               <span style="--i:10;"></span>
               <span style="--i:11;"></span>
               <span style="--i:12;"></span>
               <span style="--i:13;"></span>
               <span style="--i:14;"></span>
               <span style="--i:15;"></span>
               <span style="--i:16;"></span>
               <span style="--i:17;"></span>
               <span style="--i:18;"></span>
               <span style="--i:19;"></span>
               <span style="--i:20;"></span>
          </div>
        </div>
        <router-view/>
        <vue-confirm-dialog class="app-confirm-dialog"></vue-confirm-dialog>
    </div>
</template>


<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";

export default {
    name: "App",
    mounted() {
        this.setCommonErrors([]);
        this.setErrorMessage(null);
        if (this.getAuthUser == null) {
            // this.logout();
        }
    },
    methods: {
        ...mapActions([
            'setAuth',
            'clearAuth',
            'setLoginLoading',
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage'
        ]),
        logout() {
            let self = this;
            this.setLoginLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .post(window.route('logout'), this.form, {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    }
                })
                .then(({data}) => {
                    if (data.errors) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        localStorage.removeItem('auth');
                        self.clearAuth();
                        self.$router.push({name: 'login'});
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);
                })
                .finally(() => {
                    self.setLoginLoading(false);
                });
        },
        isLoading() {
            return this.loading == true ||
                this.ordersLoading == true ||
                this.purchaseOrdersLoading == true ||
                this.getQuotationsLoading == true ||
                this.customersLoading == true ||
                this.loginLoading == true ||
                this.productsLoading == true ||
                this.quoteProductsLoading == true;
        },

        handleClick(){
            this.$confirm(
                {
                    message: `Are you sure?`,
                    button: {
                        no: 'No',
                        yes: 'Yes'
                    },
                    /**
                     * Callback Function
                     * @param {Boolean} confirm
                     */
                    callback: confirm => {
                        if (confirm) {

                        }
                    }
                }
            )
        }
    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'getJWTToken',
            'loading',
            'ordersLoading',
            'purchaseOrdersLoading',
            'getQuotationsLoading',
            'customersLoading',
            'loginLoading',
            'productsLoading',
            'quoteProductsLoading'
        ])
    },

}
</script>

<style>

</style>
